<!-- FREEFORM COMPONENT - is not connected to control, we get result by emmiting value outside -->

<div class="check-box-freeform">
  @if (helpText) {
    <app-help-text [dataContext]="helpText" [checkbox]="true"></app-help-text>
  }
  <mat-checkbox [checked]="initialValue" [class.mr-4]="helpText" (change)="onCheckboxChange($event)">
    {{ caption | translate }}
  </mat-checkbox>
  <!-- @if (errorMessage) { <mat-hint class="error-message">{{ errorMessage }}</mat-hint> } -->
</div>
